// The source carousel markup/settings are copied from bundle-new. Keep its mounted
// content alive when Shopify re-renders the separate bundle layout in the editor.
let swiperReady;
function loadSwiper(src) {
  if (window.Swiper) return Promise.resolve(window.Swiper);
  if (!swiperReady) swiperReady = new Promise((resolve, reject) => {
    const script = document.createElement('script'); script.src = src;
    script.onload = () => window.Swiper ? resolve(window.Swiper) : reject(new Error('Video carousel unavailable'));
    script.onerror = () => { swiperReady = null; reject(new Error('Video carousel unavailable')); };
    document.head.append(script);
  });
  return swiperReady;
}
if (!customElements.get('elliosa-bp2-videos')) customElements.define('elliosa-bp2-videos', class extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.idSuffix = this.dataset.sectionId;
    this.on(document, 'shopify:section:load', () => this.mount());
    this.on(document, 'shopify:section:unload', event => {
      if (this.content && event.target.contains(this.content)) {
        this.close();
        this.querySelector('template').content.append(this.content);
      }
    });
    this.on(document, 'shopify:section:select', event => {
      if (event.target.contains(this)) this.content?.scrollIntoView({block:'center',behavior:'smooth'});
    });
    if (document.readyState === 'loading') this.on(document, 'DOMContentLoaded', () => this.mount());
    else this.mount();
  }
  on(target, type, callback) { target?.addEventListener(type, callback, {signal:this.abort.signal}); }
  select(name, parent = document) { return parent.querySelector(`.${name}-${this.idSuffix}`); }
  async mount() {
    if (!this.isConnected) return;
    const target = document.querySelector('elliosa-bundle-product-2 [data-bp2-video-reviews]');
    if (!target) {
      if (this.content?.isConnected) { this.close(); this.querySelector('template').content.append(this.content); }
      return;
    }
    this.content ||= this.querySelector(`#ss-product-video-${this.idSuffix}`)?.content.firstElementChild;
    this.modal ||= this.querySelector(`#ss-product-video-modal-${this.idSuffix}`)?.content.firstElementChild;
    if (!this.content || !this.modal) return;
    if (this.content.parentElement !== target) target.append(this.content);
    if (!this.modal.isConnected) document.body.append(this.modal);
    if (this.slider) { this.slider.update(); return; }
    if (this.initializing) return;
    this.initializing = true;
    try {
      const Swiper = await loadSwiper(this.dataset.swiperSrc);
      if (!this.isConnected || !this.content.isConnected) return;
      this.slider = new Swiper(this.select('video-slider'), {
        speed:300, slidesPerView:'auto',
        navigation:{nextEl:this.select('video-btn-next'),prevEl:this.select('video-btn-prev')},
        breakpoints:{320:{spaceBetween:Number(this.dataset.gapMobile)},768:{spaceBetween:Number(this.dataset.gapMobile)},1024:{spaceBetween:Number(this.dataset.gap)}}
      });
      this.modalSlider = new Swiper(this.select('video-modal-slider'), {
        speed:300, slidesPerView:1, allowTouchMove:false, spaceBetween:20,
        navigation:{nextEl:this.select('video-modal-next'),prevEl:this.select('video-modal-prev')},
        on:{slideChange:() => { if (this.modal.classList.contains('active')) this.playActive(); }}
      });
      this.content.querySelectorAll(`.video-slide-video-${this.idSuffix}`).forEach((trigger,index) => {
        this.on(trigger,'click',() => this.open(index,trigger));
        this.on(trigger,'keydown',event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); this.open(index,trigger); } });
      });
      this.on(this.select('video-modal-close'),'click',() => this.close());
      this.on(this.modal,'click',event => { if (event.target === this.modal) this.close(); });
      this.on(document,'keydown',event => {
        if (!this.modal.classList.contains('active')) return;
        if (event.key === 'Escape') this.close();
        if (event.key === 'Tab') {
          const controls = [...this.modal.querySelectorAll('button,[tabindex="0"]')].filter(el => el.getClientRects().length && !el.disabled);
          const first = controls[0], last = controls.at(-1);
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        }
      });
      this.modal.querySelectorAll(`.video-modal-action-${this.idSuffix}`).forEach(toggle => {
        toggle.setAttribute('role','button'); toggle.tabIndex = 0;
        toggle.setAttribute('aria-label','Mute or unmute customer video');
        const mute = () => {
          const active = toggle.classList.toggle('active');
          const slide = toggle.closest(`.video-modal-slide-${this.idSuffix}`);
          const video = slide.querySelector('video'), frame = slide.querySelector('iframe');
          if (video) video.muted = !active;
          if (frame) frame.src = active ? frame.dataset.src2 : frame.dataset.src;
        };
        this.on(toggle,'click',mute);
        this.on(toggle,'keydown',event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); mute(); } });
      });
      this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        this.loadMedia(entry.target, true); this.observer.unobserve(entry.target);
      }), {rootMargin:'300px'});
      this.content.querySelectorAll('[data-src]').forEach(media => this.observer.observe(media));
    } catch (error) { console.warn(error.message); }
    finally { this.initializing = false; }
  }
  loadMedia(media, preview = false) {
    if (!media.getAttribute('src') && media.dataset.src) media.src = media.dataset.src;
    if (media.tagName === 'VIDEO') {
      media.muted = preview;
      media.play()?.catch(() => {});
    }
  }
  open(index, trigger) {
    if (!this.modal.classList.contains('active')) this.previousOverflow = document.body.style.overflow;
    this.trigger = trigger;
    this.modal.classList.add('active'); this.modal.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    this.modalSlider.update(); this.modalSlider.slideTo(index,0); this.playActive();
    this.select('video-modal-close').focus({preventScroll:true});
  }
  playActive() {
    this.modalSlider.slides.forEach((slide,index) => {
      const video = slide.querySelector('video'), frame = slide.querySelector('iframe');
      if (index === this.modalSlider.activeIndex) {
        if (video) this.loadMedia(video);
        if (frame) frame.src = frame.dataset.src2 || frame.dataset.src;
        this.select('video-modal-action',slide)?.classList.add('active');
      } else {
        video?.pause();
        if (frame?.getAttribute('src')) frame.removeAttribute('src');
      }
    });
  }
  close() {
    if (!this.modal?.classList.contains('active')) return;
    this.modal.classList.remove('active'); this.modal.setAttribute('aria-hidden','true');
    document.body.style.overflow = this.previousOverflow ?? '';
    this.modal.querySelectorAll('video').forEach(video => { video.pause(); video.currentTime = 0; });
    this.modal.querySelectorAll('iframe').forEach(frame => frame.removeAttribute('src'));
    if (this.trigger?.isConnected) this.trigger.focus({preventScroll:true});
  }
  disconnectedCallback() {
    this.close(); this.abort?.abort(); this.observer?.disconnect();
    this.slider?.destroy(true,true); this.modalSlider?.destroy(true,true);
    this.slider = null; this.modalSlider = null;
    if (this.content) this.querySelector('template').content.append(this.content);
    if (this.modal) this.querySelector(`#ss-product-video-modal-${this.idSuffix}`).content.append(this.modal);
  }
});
